import { useSearchParams } from "react-router-dom";
import { useCallback, useMemo } from "react";

export function useDateRange() {
  const [params, setParams] = useSearchParams();
  const from = params.get("from") || "";
  const to = params.get("to") || "";

  const range = useMemo(() => ({ from, to }), [from, to]);

  const setRange = useCallback(
    (next: { from?: string; to?: string }) => {
      const p = new URLSearchParams(params);
      if (next.from) p.set("from", next.from); else p.delete("from");
      if (next.to) p.set("to", next.to); else p.delete("to");
      setParams(p, { replace: true });
    },
    [params, setParams]
  );

  const clear = useCallback(() => setRange({}), [setRange]);

  return { range, setRange, clear };
}
